export type GifGenerationFailureReason =
    | 'artboard_unavailable'
    | 'encoding_aborted'
    | 'encoding_failed'
    | 'encoding_timeout'
    | 'renderer_unavailable'
    | 'render_failed'
    | 'unexpected_exception'

export class GifGenerationError extends Error {
    readonly code: GifGenerationFailureReason
    readonly cause?: unknown

    constructor(code: GifGenerationFailureReason, message: string, cause?: unknown) {
        super(message)
        this.name = 'GifGenerationError'
        this.code = code
        this.cause = cause
    }
}
